import { render, staticRenderFns } from "./SquareVideoFrame.vue?vue&type=template&id=6af3bd98&scoped=true&"
import script from "./SquareVideoFrame.vue?vue&type=script&lang=js&"
export * from "./SquareVideoFrame.vue?vue&type=script&lang=js&"
import style0 from "./SquareVideoFrame.vue?vue&type=style&index=0&id=6af3bd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3bd98",
  null
  
)

export default component.exports